import { CourtDto } from '../../court/dto/court.dto';

export enum Currency {
  USD = 'usd',
  EUR = 'eur',
}

export type CourtPricingRuleDto = {
  daysOfWeek: number[];
  startTime: string;
  endTime: string;
  price: number;
  currency: Currency;
  courtId: number;
  id: string;
  priceDuration: number;
  // court: CourtDto;
};

export type GetCourtPricingRulesOutputDto = {
  court: CourtDto;
  rules: Omit<CourtPricingRuleDto, 'court'>[];
}[];
